import { Text } from "dash-styled"
import { metaAI } from "neql"
import React, { FC } from "react"

interface AITrainingStatusProps {
    trainingInstanceState?: metaAI.Meta_Ai_Training_State_Enum
    className?: string
}

export const AITrainingStatus: FC<AITrainingStatusProps> = ({
    trainingInstanceState = metaAI.Meta_Ai_Training_State_Enum.Stopped,
    className
}) => {
    return (
        <Text
            className={`${className} capitalize`}
            component="span"
            size="sm"
            weight="regular"
            color={
                trainingInstanceState ===
                metaAI.Meta_Ai_Training_State_Enum.InProgress
                    ? "coldgreen"
                    : trainingInstanceState ===
                      metaAI.Meta_Ai_Training_State_Enum.InternalError
                    ? "red"
                    : "gray"
            }
        >
            {trainingInstanceState.replace(/_/g, " ").toLowerCase()}
        </Text>
    )
}
